// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1555":"3d121886","5363":"d33a4b81","6171":"ef6fc020","7735":"d33a4b81","9127":"c12f4d97"}[chunkId] + ".chunk.css";
};